import { Container, Row } from "reactstrap";
import CustomScrollbar from "./CustomScrollbar";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, ScrollableTitle } from "../../../Constants/Constants";
import SmallSizeScroll from "./SmallSizeScroll";
import BadgesScrollbar from "./BadgesScrollbar";
import ProfileScrollable from "./ProfileScrollable";
import ScrollableContent from "./ScrollableContent";
import HorizontalScrollbar from "./HorizontalScrollbar";
import BothSideScrollbar from "./BothSideScrollbar";

const ScrollableContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ScrollableTitle} parent={BonusUi} />
      <Container fluid className="list-page">
        <Row>
          <CustomScrollbar />
          <SmallSizeScroll />
          <BadgesScrollbar />
          <ProfileScrollable />
          <ScrollableContent />
          <HorizontalScrollbar />
          <BothSideScrollbar />
        </Row>
      </Container>
    </>
  );
};

export default ScrollableContainer;
